(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
jQuery( document ).ready(function() {     
    var elem = new Foundation.Accordion($('.accordion'));
    console.log('elem',elem);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
jQuery( document ).ready(function() {     
    var elem = new Foundation.Equalizer($('.icons-grid'));            
    Foundation.reInit("equalizer")
});
$(window).load(function() {
    Foundation.reInit("equalizer");
});

  } catch(e) { console.error(e); }
})();
})();
